import { render } from "./GridPromoTile.vue?vue&type=template&id=19522500&scoped=true"
import script from "./GridPromoTile.vue?vue&type=script&lang=js"
export * from "./GridPromoTile.vue?vue&type=script&lang=js"

import "./GridPromoTile.vue?vue&type=style&index=0&id=19522500&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19522500"]])

export default __exports__